import SquareIcon from '@mui/icons-material/Square';
import { createColumnHelper } from '@tanstack/react-table';
import { L } from 'harmony-language';
import React from 'react';
import type { LocationTypeColor } from '../../../types';
import { useLocationTypes } from '../../../api/queries/use-location-types';

export const useLocationTypeColorColumns = () => {
    const columnHelper = createColumnHelper<LocationTypeColor>();
    const { data: locationTypes = [] } = useLocationTypes();

    const columns = React.useMemo(() => ([
        columnHelper.accessor('organizationLocationTypeId', {
            header: L.locationType(),
            cell: (info) => locationTypes.find(type => type.id === info.getValue())?.name,
            enableColumnFilter: false,
        }),
        columnHelper.accessor('hexColor', {
            header: L.color(),
            cell: (info) => <SquareIcon style={{ color: info.getValue() }} />,
            enableColumnFilter: false,
            enableSorting: false,
        })
    ]), [locationTypes]);

    return columns;
}